import Image from "next/image";
import closeImg from "../../../new-images/closeicon.svg";
import styles from './styles.module.scss';
import { useEffect, useRef } from "react";
import html2canvas from "html2canvas";
import { getAchCategory } from "../utils";

export const AchievementPopup = ({
  onClose,
  achData,
  inProfile = true
}) => {
  const captureRef = useRef(null);

  const date = new Date(achData.claimedDate);

  const formattedDate = date.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });

  useEffect(() => {
    document.body.classList.add('dimmable');

    return () => {
      document.body.classList.remove('dimmable');
    };
  }, []);

  const screenShot = (
    <div ref={captureRef} style={{ position: "fixed", top: "-9999px", left: "-9999px", zIndex: 10000 }}>
      <div className={styles.shareAch}>
        <div className={styles.shareAchContent}>
          <p className={styles.shareAch_title}>у меня есть достижение</p>
          <p className={styles.shareAch_name}>{achData.name}</p>
          <img
            className={styles.shareAch_icon}
            src={`/static/images/achievements/${getAchCategory(achData.type)}/${achData.type}.png`}
            alt={achData.name}
          />
          <div
            className={styles.shareAch_desc}
            dangerouslySetInnerHTML={{
              __html: achData.shortDescription,
            }} />
          <div className={styles.DSImage}>
            <img src={"/static/images/newLogoIcon.png"} alt="" />
          </div>
        </div>
      </div>
    </div>
  )

  const handleCaptureClick = async () => {
    if (captureRef.current) {
      const canvas = await html2canvas(captureRef.current, {
        useCORS: true,
        scale: 2
      });
      const imgData = canvas.toDataURL('image/png');

      // Создание файла из изображения
      const blob = await (await fetch(imgData)).blob();
      const file = new File([blob], 'my-profile-donorsearch.png', { type: 'image/png' });

      const isMobile = /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

      // Проверка поддержки Web Share API и возможности передачи файлов
      if (navigator.canShare && navigator.canShare({ files: [file] }) && isMobile) {
        try {
          await navigator.share({
            files: [file],
          });
        } catch (error) {
          console.error('Sharing failed:', error);
        }
      } else {
        const link = document.createElement('a');
        link.href = imgData;
        link.download = 'my-ach-donorsearch.png';
        link.click();
      }
    }
  };

  return (
    <>
      {screenShot}
      <div className={styles.popupOverlay} onClick={onClose}>
        <div className={styles.popup} onClick={(e) => e.stopPropagation()}>
          <div className={styles.popupClose}>
            <Image
              src={closeImg}
              width={16}
              height={16}
              onClick={onClose}
            />
          </div>
          <div className={styles.popupContent}>
            <p className={styles.popupContent_name}>{achData.name}</p>
            <img
              src={`/static/images/achievements/${getAchCategory(achData.type)}/${achData.type}.png`}
              alt={achData.name}
            />
            {inProfile && <p className={styles.popupContent_date}>Получено: {formattedDate}</p>}
            <div
              className={styles.popupContent_shortdesc}
              dangerouslySetInnerHTML={{
                __html: achData.shortDescription,
              }}
            />

            {inProfile && <button onClick={handleCaptureClick}>Рассказать друзьям</button>}
          </div>
        </div>
      </div>
    </>
  );
};